import { render, staticRenderFns } from "./side-by-side-grid-icon.vue?vue&type=template&id=219310cb&scoped=true&"
import script from "./side-by-side-grid-icon.vue?vue&type=script&lang=js&"
export * from "./side-by-side-grid-icon.vue?vue&type=script&lang=js&"
import style0 from "./side-by-side-grid-icon.vue?vue&type=style&index=0&id=219310cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219310cb",
  null
  
)

export default component.exports